import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/components/page/Home'
import Browse from '@/components/page/Browse'
import Search from "@/components/page/Search";
import Dataset_v1 from "@/components/page/Dataset_v1";
import Compare from "@/components/page/Compare";
import Upload from "@/components/page/Upload";
import Explorer from "@/components/page/Explorer";
import InferCNV from "@/components/page/InferCNV";
import SVG from "@/components/page/SVG";
import CellType from "@/components/page/CellType";
import Marker from "@/components/page/Marker";
import Download from "@/components/page/Download";
import Help from "@/components/page/Help";
import Test from "@/components/page/Test";
import State from "@/components/page/State";
import Test2 from "@/components/page/test2"
import xmlTest from "@/components/tools/xmlTest";
import Dataset_v2 from "@/components/page/Dataset_v2";
import PanCancer from "@/components/page/PanCancer";
import Overview_grid from "@/components/Dataset/Overview_grid";
import CalDataset from "@/components/page/CalDataset";

// 初始化 VueRouter 插件
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

// 创建路由
export default new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Home1',
            component: Home
        },
        {
            path: '/Home',
            name: 'Home2',
            component: Home
        },
        {
            path: '/Browse',
            name: 'Browse',
            component: Browse
        },
        {
            path: '/Search',
            name: 'Search',
            component: Search
        },
        {
            path: '/Dataset',
            name: 'Dataset_v2',
            component: Dataset_v2
        },
        {
            path: '/Dataset/type/:type',
            name: 'Dataset_v2',
            component: Dataset_v2
        },
        {
            path: '/Compare',
            name: 'Compare',
            component: Compare
        },
        {
            path: '/Upload',
            name: 'Upload',
            component: Upload
        },
        {
            path: '/Explorer',
            name: 'Explorer',
            component: Explorer
        },
        {
            path: '/InferCNV',
            name: 'InferCNV',
            component: InferCNV
        },
        {
            path: '/State',
            name: 'State',
            component: State
        },
        {
            path: '/Dataset/SVG/:id',
            name: 'SVG',
            component: SVG
        },
        {
            path: '/Dataset/Celltype/:id',
            name: 'CellType',
            component: CellType
        },
        {
            path: '/Dataset/Marker/:id',
            name: 'my_marker',
            component: Marker
        },
        {
            path: '/Download',
            name: 'Download',
            component: Download
        },
        {
            path: '/Help',
            name: 'Help',
            component: Help
        },
        {
            path: '/xml_test',
            name: 'xmlTest',
            component: xmlTest
        },
        {
            path: '/Dataset_v2',
            name: 'Dataset_v2',
            component: Dataset_v2
        },
        {
            path: '/Dataset_v1',
            name: 'Dataset_v1',
            component: Dataset_v1
        },
        {
            path: '/PanCancer',
            name: 'PanCancer',
            component: PanCancer
        },
        {
            path: '/test',
            name: 'test',
            component: Test
        },
        {
            path: '/test2',
            name: 'test2',
            component: Test2
        },
        {
            path: '/test_grid',
            name: 'test_grid',
            component: Overview_grid
        },
        {
            path: '/CalDataset',
            name: 'CalDataset',
            component: CalDataset
        },
    ]
})
